export interface GoodsKPIReport {
    summary: GoodsSummaryKPIReport;
    productWithTerminalId: ProductLineWithTerminalIdGoodsKPIReport[];
}

export interface GoodsSummaryKPIReport {
    totalOrders: number;
    cancelledByShop: number;
    orderSuccess: number;
    isOwnAmount: number;
    isPredefinedValue: number;
    soldTotal: number;
    discounted: number;
    totalDiscounts: number;
    soldAverage: number;
    serviceFeeAmount: number;
    withServiceFee: number;
}

export interface ProductLineWithTerminalIdGoodsKPIReport {
    totalOrders: number;
    cancelledByShop: number;
    orderSuccess: number;
    isOwnAmount: number;
    isPredefinedValue: number;
    soldTotal: number;
    discounted: number;
    totalDiscounts: number;
    productLineName: string;
    terminalId: string;
    soldAverage: number;
    serviceFeeAmount: number;
    withServiceFee: number;
}
